@if (unfinishedRoomInitialised()) {
  @if (!hasUnfinishedRoom()) {
    <div class="tier-first-overlay">
      <div class="tier-first-content">
        <app-wager-tier-list
          [allTiers]="allTiersSignal"
          [currentTournamentData]="currentTournamentDataSignal"
          [waitingOpponentsStandard]="waitingOpponentsStandard"
          (wagerClickEvent)="onWagerClick($event)"
          (tournamentPlayClickEvent)="onTournamentPlayClick($event)"
          (practiceClickEvent)="onPracticeClick()"
          (localClickEvent)="onLocalClick()"
        />
      </div>
    </div>
  } @else {
    <div class="continue-game-footer">
      <app-countdown-pill
        class="time-remaining"
        [timeRemaining]="unfinishedTimeRemaining()"
        size="small"
      />
      <app-button
        [label]="continueButtonLabel()"
        variant="primary"
        stretch="fill"
        (clickEvent)="continueGameClicked()"
      />
    </div>
  }
}
